module.exports = __webpack_public_path__ + "img/1492418179.1e9fb608.jpg";